import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { useScroll, useSpring, motion } from "framer-motion";
import { bloggerPostDetails, GetPostsResponse } from '../types/bloggerServices';
import { getPost } from '../services/blogger';

const PostDetails: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const [post, setPost] = useState<bloggerPostDetails>();
  
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const getData = async (postSlug: string) => {
    try{
      console.log("slug: ", slug)
      const response = await getPost(postSlug);
      console.log("response: ", response)

      setPost({
        title: response.title,
        author: {
            displayName: response.author.displayName,
            id: response.author.id,
            image: response.author.image,
        },
        content: response.content,
        published: response.published,
      })
    }
    catch(e){
      console.log(e);
    }
  }

  useEffect(() => {
    slug && getData(slug)
  }, [slug]);
  
  if (!post) {
    return (
      <Container className="post-details">
        <h2>Post not found</h2>
      </Container>
    );
  }
  
  // Format date to Ethiopian format
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };
  
  return (
    <Container className="post-details route-container">
      <motion.div className="progressBar" style={{ scaleX }} />
      <Row className="justify-content-center">
        <Col lg={10} xl={8}>
          <div className="post-header">
            <h1 className="post-title">{post.title}</h1>
            
            <div className="post-meta">
              <div className="author-info">
                <p className="author-name">By {post.author.displayName}</p>
                <p className="post-date">{formatDate(post.published)}</p>
              </div>
            </div>
          </div>
          
          <div className="post-content">
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
          </div>
          
          {/**
           * <div className="post-footer">
            <div className="tags">
              <span className="tag">ፋጤ</span>
              <span className="tag">መፅሔት</span>
              <span className="tag">ብሎግ</span>
            </div>
          </div>
           */}
        </Col>
      </Row>
    </Container>
  );
};

export default PostDetails;